import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import SearchFrom from './components/globasearch/search-entry.vue';
// import SearchFrom from './components/globasearch/search-from.vue';
import SearchTag from './components/globasearch/search-tag.vue';
import { isEmpty } from 'lodash';
import { searchCenterStore } from '@blade-sxp/search-center/store/searchCenter';
import { remove } from '@blade-sxp/search-center/utils/index';
import { queryType } from '@blade-sxp/search-center/interfaces/enum';
import { searchStore } from '@blade-sxp/search-center/store/search';
import { LoginModule } from '@blade/common/store/login';
let SearchCenter = class SearchCenter extends Vue {
    linkList = []; // 事件下拉数据
    time = [];
    langeName = false;
    featureList = [];
    defaultEvent = []; // 默认展示第一个事件
    typeList = ['event', 'vehicleNo', 'picture', 'text']; // 默认下拉事件
    init() {
        this.eventType();
        this.vehicleType();
    }
    //  硬狗获取 是否有车
    async vehicleType() {
        const res = LoginModule.hardDogAbility;
        console.log('res', res);
        const hasAutoMobile = res.some((item) => {
            return item.labels[0].code === queryType.AUTOMOBILE;
        });
        !hasAutoMobile && (this.typeList = remove(this.typeList, 'vehicleNo'));
        const hasRetention = res.some((item) => {
            return item.labels[0].code === queryType.EVERYTHING;
        });
        !hasRetention && (this.typeList = remove(this.typeList, 'text'));
        // 获取初始化属性
        this.featureList = res.map((item) => {
            return {
                attributeMaps: {},
                featureType: item.labels[0].code,
                featureValue: '',
                imageUrl: '',
                version: null,
                name: item.labels[0].name,
            };
        });
        searchCenterStore.updateFeatureList(this.featureList);
    }
    // 事件类型 硬狗获取
    async eventType() {
        const arr = await searchStore.getEventType();
        this.linkList = this.treeCustomName(arr);
        // 没有事件权限
        if (!this.linkList.length)
            this.typeList = remove(this.typeList, 'event');
        this.defaultArr(this.linkList);
    }
    // 事件默认选中第一个数据
    defaultArr(arr) {
        arr.map((item, index) => {
            if (index === 0) {
                this.defaultEvent.push(item.value);
                if (item.children) {
                    this.defaultArr(item.children);
                }
            }
        });
    }
    // 修改成联级选择器符合的格式
    treeCustomName = (tree) => {
        const deep = (datas) => {
            if (!isEmpty(datas)) {
                const data = datas.map((item) => {
                    return {
                        value: item?.labels[0]?.code,
                        label: item?.labels[0]?.name,
                        children: item?.subAttributes && item?.subAttributes?.length > 0 ? deep(item.subAttributes) : null,
                    };
                });
                return data;
            }
        };
        return deep(tree);
    };
    created() {
        this.init();
    }
};
SearchCenter = __decorate([
    Component({
        name: 'SearchCenter',
        components: { SearchFrom, SearchTag },
    })
], SearchCenter);
export default SearchCenter;
